import { useEffect, useState } from 'react';
import Link from 'next/link';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem('cookieConsent');
    if (!accepted) setVisible(true);
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'true');
    setVisible(false);
    // Optional: fire GA manually if you're delaying until consent
    // window.gtag && window.gtag('consent', 'update', { ad_storage: 'granted', analytics_storage: 'granted' });
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 w-full bg-white text-black text-sm p-3 z-50">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row justify-between items-center text-center gap-2">
        <p>
          This website uses cookies for analytics, advertising insights, and security. By using our site, you agree to data collection.{' '}
          {/*  This website uses cookies for analytics (Google Analytics) and bot protection (Google reCAPTCHA).{' '}*/}
          <Link href="/privacy-policy" className=" text-primary hover:underline" prefetch={false}>Read Our Privacy Policy</Link>.
        </p>
        <button
          onClick={handleAccept}
          className="mt-2 md:mt-0 bg-primary text-white px-8 py-2 uppercase text-md font-light tracking-[3px] hover:bg-black"
        >
          Accept
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
